import { FC } from 'react';
import { EmptyState } from '@silverfort/sf-components';

const FavoritesEmptyState: FC = () => (
    <EmptyState
        className="py-8"
        contentClassName="h-[46.56px] [&]:justify-start"
        title="No Favorites"
        description="Add your favorite templates for quick access."
    />
);

export default FavoritesEmptyState;
